import {
  all,
  put,
  call,
  takeEvery,
  select,
  takeLatest
} from 'redux-saga/effects'

import { getTransactions, getTransactionDetail } from '../api'
import { apiError, showPopup } from '../helpers'
import { captureException } from '../helpers/Sentry'
import { logout, LOGOUT } from './auth'

const initialState = {
  propertyId: '',
  productId: '',
  entities: [],
  limit: 10,
  isMoreToLoad: true,
  offset: 0,
  error: null,
  loading: false,
  detailLoading: false,
  detailError: null,
  selectedTransactionId: '',
  currentTransaction: {
    num: '',
    insert_time: '',
    requestor_name: '',
    subject: '',
    status: '',
    accept_time: '',
    cancel_time: '',
    hours: '',
    hour_type: '',
    work_text: '',
    planned_date: ''
  }
}

export const moduleName = 'transactions'
export const INITIALIZE = `${moduleName}/INITIALIZE`

export const FETCH_TRANSACTIONS_REQUEST = `${moduleName}/FETCH_TRANSACTIONS_REQUEST`
export const FETCH_TRANSACTIONS_SUCCESS = `${moduleName}/FETCH_TRANSACTIONS_SUCCESS`
export const FETCH_TRANSACTIONS_FAIL = `${moduleName}/FETCH_TRANSACTIONS_FAIL`

export const FETCH_TRANSACTION_DETAIL_REQUEST = `${moduleName}/FETCH_TRANSACTION_DETAIL_REQUEST`
export const FETCH_TRANSACTION_DETAIL_SUCCESS = `${moduleName}/FETCH_TRANSACTION_DETAIL_SUCCESS`
export const FETCH_TRANSACTION_DETAIL_FAIL = `${moduleName}/FETCH_TRANSACTION_DETAIL_FAIL`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case INITIALIZE:
      return { ...initialState, loading: true, ...payload }

    case FETCH_TRANSACTIONS_REQUEST:
      return { ...state, loading: true }

    case FETCH_TRANSACTIONS_SUCCESS:
      return { ...state, loading: false, ...payload }

    case FETCH_TRANSACTIONS_FAIL:
      return { ...state, loading: false, isMoreToLoad: false, error: payload }

    case FETCH_TRANSACTION_DETAIL_REQUEST:
      return { ...state, detailLoading: true, selectedTransactionId: payload }

    case FETCH_TRANSACTION_DETAIL_SUCCESS:
      return { ...state, detailLoading: false, currentTransaction: payload }

    case FETCH_TRANSACTION_DETAIL_FAIL:
      return { ...state, detailLoading: false, detailError: payload }

    case LOGOUT:
      return { ...initialState }

    default:
      return state
  }
}

export function initializeTransactions(payload) {
  return {
    type: INITIALIZE,
    payload
  }
}

export function fetchTransactions() {
  return {
    type: FETCH_TRANSACTIONS_REQUEST
  }
}

export function fetchTransactionDetail(id) {
  return {
    type: FETCH_TRANSACTION_DETAIL_REQUEST,
    payload: id
  }
}

export const initializeTransactionsSaga = function*() {
  try {
    yield call(fetchTransactionsSaga)
  } catch (e) {
    console.error(e)
  }
}

export const fetchTransactionsSaga = function*() {
  try {
    const { propertyId, productId, limit, offset, entities } = yield select(
      ({ transactions }) => transactions
    )
    const response = yield call(getTransactions, {
      propertyId,
      productId,
      limit,
      offset
    })

    const payload = {
      offset: offset + limit,
      entities: [...entities, ...response]
    }

    if (response.length < limit) {
      payload.isMoreToLoad = false
    }

    yield put({
      type: FETCH_TRANSACTIONS_SUCCESS,
      payload
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: FETCH_TRANSACTIONS_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: FETCH_TRANSACTIONS_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const fetchTransactionDetailSaga = function*() {
  try {
    const { selectedTransactionId } = yield select(
      ({ transactions }) => transactions
    )

    const response = yield call(getTransactionDetail, selectedTransactionId)

    yield put({
      type: FETCH_TRANSACTION_DETAIL_SUCCESS,
      payload: { ...response }
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: FETCH_TRANSACTION_DETAIL_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: FETCH_TRANSACTION_DETAIL_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([
    takeEvery(INITIALIZE, initializeTransactionsSaga),
    takeLatest(FETCH_TRANSACTIONS_REQUEST, fetchTransactionsSaga),
    takeLatest(FETCH_TRANSACTION_DETAIL_REQUEST, fetchTransactionDetailSaga)
  ])
}
